import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `emergency-contacts`);
        return response;
    } catch (e) { }
}

export async function emergencyContactAdd(informationBody:any) {
    try {

        const response = await apiPost('core', 'emergency-contacts', informationBody);

        return response;
    } catch (e) { }
}

export async function emergencyContactUpdate(id: number, informationBody:any) {
    try {
        const response = await apiPut('core', `emergency-contacts/${id}`, informationBody);

        return response;
    } catch (e) { }
}

export async function emergencyContactRemove(id: any) {
    try {
        return await await apiDelete('core', `emergency-contacts/${id}`);
    } catch (e) { }
}